<template>
	<div>
		<button class="button stackng-button" type="button" @click.prevent="openModal()">
			<ion-icon name="ios-contacts" class="button-icon"></ion-icon>&nbsp;
			Create new group
		</button>
	</div>
</template>

<script>
export default {
	methods: {
		openModal() {
			const html = document.querySelector("html");
			const app = document.querySelector("#app");
			app.classList.add("blur-app");
			html.style.overflowY = "hidden";

			if (this.$store.state.user.authUser.emailVerified) {
				//Set payload
				let payload = {
					show: true,
					from: "",
					group: {}
				};

				//Set state
				//BUG Store commit not working
				// this.$store.commit('updateGroupsModal', payload)
				this.$store.state.app.app.groupsModal.show = true;
				this.$store.state.app.app.groupsModal.from = "";
				this.$store.state.app.app.groupsModal.group = null;
			} else {
				//Incase button is clicked from groups modal
				this.$store.state.app.app.groupsModal.show = false;

				let payload = {
					show: true,
					action: "verify-email"
				};

				this.$store.commit("updateAccountModal", payload);
			}
		}
	}
};
</script>

<style scoped>
.button-icon {
	font-size: 17px;
}

.stackng-button {
	width: 100%;
	padding: 12px 20px;
	font-size: 15px;
	font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/buttons/NewGroupButton.vue